// extracted by mini-css-extract-plugin
export default {"locationNameCell":"LocationNameCell_locationNameCell__HmMqM","locationName":"LocationNameCell_locationName__3AHDY"};